export const ceoAccountStatusReducer = (state = {}, action) => {
    switch (action.type) {
        case "UPDATECEOACCOUNT":
            return {
                ...state,
                ceoType: action.payload.ceoType,
                canceledPremium: action.payload.canceledPremium,
                estimatedCancelPremiumDttm: action.payload.estimatedCanceledPremiumDttm,
                requestCancelPremiumtDttm : action.payload.canceledReqPremiumDttm,
                isDeleted: action.payload.isDeleted,
                requestDeleteDttm: action.payload.deleteDttm,
                estimatedDeletionDttm : action.payload.estimatedDeletionDttm
            }
        default:
            return state;
    }
};

export default ceoAccountStatusReducer;